import { render } from "./RouletteGame.vue?vue&type=template&id=4ea77060&scoped=true"
import script from "./RouletteGame.vue?vue&type=script&lang=js"
export * from "./RouletteGame.vue?vue&type=script&lang=js"

import "./RouletteGame.vue?vue&type=style&index=0&id=4ea77060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea77060"]])

export default __exports__